/**
 * Utility function to show a toast notification instead of directly redirecting
 * to the free assessment page. The toast is blue and fully clickable.
 * 
 * Usage:
 * Instead of: window.location.href = 'https://www.stackguard.io/free-assessment'
 * Use: showFreeAssessmentToast()
 * 
 * @param {string} url - Optional custom URL (defaults to free-assessment page)
 */
import { toast } from 'sonner';
import { Link as LinkIcon } from 'lucide-react';

export const showFreeAssessmentToast = (url = 'https://www.stackguard.io/free-assessment') => {
  const handleClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  toast.info(
    <div 
      onClick={handleClick}
      className="flex items-center gap-2 cursor-pointer w-full"
      style={{ cursor: 'pointer' }}
    >
      <span>Please Try Out our Free Risk Assessment</span>
      <LinkIcon className="w-4 h-4 flex-shrink-0" />
    </div>,
    {
      duration: 6000,
      className: 'cursor-pointer',
      onClick: handleClick,
    }
  );
};

